import { computed, Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ApiActivityService {
  private readonly activeRequests = signal(0);

  readonly pendingRequests = computed(() => this.activeRequests());
  readonly busy = computed(() => this.activeRequests() > 0);

  async track<T>(task: () => Promise<T>): Promise<T> {
    this.activeRequests.update((value) => value + 1);

    try {
      return await task();
    } finally {
      this.activeRequests.update((value) => Math.max(0, value - 1));
    }
  }
}
